import { Cidade } from '../../../@types';

interface CidadeLabelProps {
  cidade: Cidade;
  atualizado?: string;
}

const CidadeLabel: React.FC<CidadeLabelProps> = ({ cidade, atualizado }) => (
  <div className="cidade-atualizado-row">
    <div>
      <i className="pi pi-map-marker mr-1" />
      {cidade.nome} - {cidade.uf}
    </div>
    {atualizado && (
      <div className="card-atualizado-label">
        <i className="pi pi-clock mr-1" />
        {atualizado}
      </div>
    )}
  </div>
);

export default CidadeLabel;
